/* ═══════════════════════════════════════════════════════════════════════════
 * RSV Quiz Email Validation — v1.0 (2026-04-22)
 * ═══════════════════════════════════════════════════════════════════════════
 * Lightweight client-side email validator. Catches:
 *   - Invalid format
 *   - Common typo domains (gmsil.com, gmai.com, yaho.com, hotmial.com, etc.)
 *   - Disposable-domain allowlist (optional, off by default)
 *
 * Public API:
 *   window.RSV_EMAIL_VALIDATE.validate(email)
 *     → { valid: bool, error?: string, suggestion?: string }
 *
 * Intentionally small (~100 lines). No external dependencies.
 * ═══════════════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';
  if (window.RSV_EMAIL_VALIDATE) return;

  var RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  // Common typo → suggested correction
  var TYPO_MAP = {
    'gmsil.com':      'gmail.com',
    'gmai.com':       'gmail.com',
    'gmial.com':      'gmail.com',
    'gmaill.com':     'gmail.com',
    'gmail.co':       'gmail.com',
    'gmail.cm':       'gmail.com',
    'gmail.comm':     'gmail.com',
    'gnail.com':      'gmail.com',
    'gmal.com':       'gmail.com',
    'gmil.com':       'gmail.com',
    'yaho.com':       'yahoo.com',
    'yahooo.com':     'yahoo.com',
    'yahoo.co':       'yahoo.com',
    'yaoo.com':       'yahoo.com',
    'yhoo.com':       'yahoo.com',
    'hotmial.com':    'hotmail.com',
    'hotmal.com':     'hotmail.com',
    'hotmai.com':     'hotmail.com',
    'hotmaill.com':   'hotmail.com',
    'hotmial.co':     'hotmail.com',
    'hotmail.co':     'hotmail.com',
    'outlok.com':     'outlook.com',
    'outloo.com':     'outlook.com',
    'icloud.co':      'icloud.com',
    'iclould.com':    'icloud.com',
    'aol.co':         'aol.com',
    'live.co':        'live.com',
    'comcast.ne':     'comcast.net',
    'comcast.com':    'comcast.net',
    'me.co':          'me.com'
  };

  // Known-good domains we don't need to double-check
  var KNOWN_GOOD = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com',
    'aol.com', 'live.com', 'msn.com', 'comcast.net', 'me.com', 'mac.com',
    'protonmail.com', 'pm.me', 'fastmail.com', 'zoho.com', 'yandex.com',
    'gmx.com', 'duck.com', 'rocksolidveneers.com'
  ];

  function validate(email) {
    if (!email || typeof email !== 'string') {
      return { valid: false, error: 'Enter an email address.' };
    }

    var e = email.trim().toLowerCase();

    if (!RE.test(e)) {
      return { valid: false, error: 'That doesn\u2019t look like a valid email address.' };
    }

    var at = e.indexOf('@');
    var domain = e.slice(at + 1);

    if (TYPO_MAP[domain]) {
      return {
        valid: false,
        error: 'Did you mean ' + e.slice(0, at + 1) + TYPO_MAP[domain] + '?',
        suggestion: e.slice(0, at + 1) + TYPO_MAP[domain]
      };
    }

    // If domain ends in .con/.cim/.cmo/.ocm/.vom → probably a typo on .com
    var tldFixes = { 'con': 'com', 'cim': 'com', 'cmo': 'com', 'ocm': 'com', 'vom': 'com', 'comm': 'com' };
    var dotParts = domain.split('.');
    var tld = dotParts[dotParts.length - 1];
    if (tldFixes[tld]) {
      var fixedDomain = dotParts.slice(0, -1).concat(tldFixes[tld]).join('.');
      return {
        valid: false,
        error: 'Did you mean ' + e.slice(0, at + 1) + fixedDomain + '?',
        suggestion: e.slice(0, at + 1) + fixedDomain
      };
    }

    // Warn but accept for unknown domains (we don't want to be too strict)
    return { valid: true, known: KNOWN_GOOD.indexOf(domain) !== -1 };
  }

  function validatePhone(phone) {
    if (!phone || typeof phone !== 'string') {
      return { valid: false, error: 'Enter a phone number.' };
    }
    var digits = phone.replace(/\D/g, '');
    if (digits.length < 10) {
      return { valid: false, error: 'Phone number is too short.' };
    }
    if (digits.length > 15) {
      return { valid: false, error: 'Phone number is too long.' };
    }
    // Normalize US numbers to +1 format if 10 digits
    if (digits.length === 10) {
      return { valid: true, normalized: '+1' + digits };
    }
    if (digits.length === 11 && digits.charAt(0) === '1') {
      return { valid: true, normalized: '+' + digits };
    }
    return { valid: true, normalized: '+' + digits };
  }

  window.RSV_EMAIL_VALIDATE = {
    validate: validate,
    validatePhone: validatePhone
  };
})();
